import { GatewayApi } from "./base";


class HealthConditionImpl {
    constructor(
        readonly id?: string,
        readonly name?: string,
        readonly rule?: string,
        readonly severity?: number,
        readonly check_trigger?: string,
        readonly is_active?: boolean,
        readonly last_check?: string,
        readonly source?: string
    ) {}
}

export interface HealthCondition extends HealthConditionImpl {}


class ScheduleRuleImpl {
    constructor(
        readonly name?: string,
        readonly expression?: string,
        readonly is_enabled?: boolean
    ) {}
}

export interface ScheduleRule extends ScheduleRuleImpl {}


export class HealthMonitorApi extends GatewayApi {
    constructor() {
        super('healthMonitor');
    }

    index(): Promise<HealthCondition[]> {
        return this.invoke('index', {}) ?? [];
    }

    listRules(): Promise<ScheduleRule[]> {
        return this.invoke('list_rules') ?? [];
    }

    async toggleRule(rule: ScheduleRule) {
        return this.invoke('toggle_rule', { rule_id: rule.name });
    }
}
